var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-writer-toolbar.ts
import { acss } from "@adornis/chemistry/directives/acss.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/fonts/fonts.js";
import "@adornis/forms/x-input.js";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { repeat } from "lit/directives/repeat.js";
import toolbarIcons from "./toolbarIcons.js";
import { XPlainWriterToolbar } from "./x-plain-writer-toolbar.js";
var XWriterToolbar = class extends XPlainWriterToolbar {
  renderToolbar(commands, attached) {
    return html`
      <x-flex
        flex
        horizontal
        ${css({
      background: this.colors.white,
      borderRadius: this.sizes.borderRadius,
      // border: attached ? '' : inputToken(this).border,
      // borderBottom: inputToken(this).border,
      "--icon-color": this.colors.neutral.shade(800)
      // in know this is kinda clunky, but its the best i can do without redoing the icons completely
    })}
      >
        ${repeat(
      commands,
      (c) => c,
      (cmd, index) => html`
              <x-flex
                padding="xs"
                ${css({
        userSelect: "none",
        cursor: "pointer",
        transition: "background .2s"
        // borderRight: index === commands.length - 1 ? '' : inputToken(this).border,
      })}
                ${acss({ "&:hover": { background: this.colors.neutral.shade(100) } })}
                @click=${() => this.handleFormat(cmd.name)}
              >
                <x-flex ${css({ width: "20px" })}> ${toolbarIcons[cmd.name]} </x-flex>
              </x-flex>
            `
    )}
      </x-flex>
    `;
  }
  renderInput(attached) {
    return html`
      <x-flex
        flex
        horizontal
        ${css({
      background: this.colors.white,
      borderRadius: this.sizes.borderRadius
    })}
      >
        <x-input
          flex
          id="input"
          @submit=${(e) => this.inputSubmit(e)}
          @escape=${(e) => this.inputEscape(e)}
        ></x-input>
      </x-flex>
    `;
  }
};
XWriterToolbar = __decorateClass([
  customElement("x-writer-toolbar")
], XWriterToolbar);
export {
  XWriterToolbar
};
